export default __webpack_public_path__ + "static/media/top.28168fd7.png";